import React, { Component } from 'react'
import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { presets } from 'react-motion'
import truncate from 'html-truncate'
import Collapse from 'components/Collapse'
import plusSvg from 'icons/plusIcon'
import minusSvg from 'icons/minusIcon'
import RichText from 'components/RichText'
import styles from './collapsed-style.css'

const propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
}

// Add any default values for props
const defaultProps = {
  isOpen: false,
}

class Collapsed extends Component {
  state = {
    isOpened: false,
  }

  componentDidMount() {
    if (process.env.NODE_ENV !== 'test') {
      this.setOverflow()
      this.props.isOpen && this.handleOpen()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen) {
      this.handleOpen()
    }
  }

  handleOpen = () => {
    this.setState((prevState, nextState) => ({
      isOpened: !prevState.isOpened,
      height: prevState.isOpened ? '100px' : this.getWrapperHeight(),
      contentHeight: this.getContentHeight(),
      isOverflowing: prevState.isOpened ? this.setOverflow() : false,
    }))
  }

  getWrapperHeight = () => this.wrapper.clientHeight

  getContentHeight = () => this.collapseContent.clientHeight

  setOverflow = () => {
    setTimeout(() => {
      this.setState(() => ({
        isOverflowing: this.getContentHeight() > this.getWrapperHeight() - 50,
        displayButton: this.getContentHeight() > 50,
      }))
    }, 200)
  }

  render() {
    const { content, title } = this.props
    const { isOpened = false, isOverflowing, displayButton } = this.state

    return (
      <div
        ref={c => (this.wrapper = c)}
        className={styles.collapsed}
        aria-expanded={isOpened}
        data-readaloud
      >
        {displayButton && (
          <button
            className={styles.btn}
            onClick={this.handleOpen}
            style={{
              transform: isOpened && 'rotateZ(180deg)',
            }}
            ref={btn => (this.btn = btn)}
            aria-label="vis/skjul tekst"
          >
            {isOpened ? minusSvg() : plusSvg()}
          </button>
        )}
        <h2>{title}</h2>
        <Collapse
          minHeight={50}
          isOpened={isOpened}
          springConfig={presets.noWobble}
        >
          <div ref={c => (this.collapseContent = c)}>
            <RichText
              className={styles.content}
              isOverflowing={isOverflowing}
              html={isOverflowing ? truncate(content, 135) : content}
            />
          </div>
        </Collapse>
      </div>
    )
  }
}

Collapsed.displayName = 'Collapsed'
Collapsed.propTypes = propTypes
Collapsed.defaultProps = defaultProps

export default Collapsed



// WEBPACK FOOTER //
// ./src/components/Collapsed/Collapsed.js